import { Component } from 'react';
import './Settings.js';
import languages from '../languages.js';
import IconPadlock from './IconPadlock.js';

class Settings extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openaiApiKey: '',
			oldOpenaiApiKey: '',
		};

		this.handleInput = this.handleInput.bind(this);

		this.limits = {
			maxSentencesPerParagraph: {
				min: 1,
				max: 10,
			},
			maxWordsPerParagraph: {
				min: 1,
				max: 200,
			},
			maxParagraphsPerHeading: {
				min: 1,
				max: 10,
			},
			maxWordsInIntro: {
				min: 1,
				max: 100,
			},
			maxWordsPerSentence: {
				min: 1,
				max: 30,
			},
		};
	}

	handleInput(event) {
		if (event.target.dataset.option === 'openaiApiKey') {
			this.setState({
				openaiApiKey: event.target.value,
			});
			return;
		}
		let settingName = event.target.dataset.option;
		let settingValue = event.target.value;
		if (settingName in this.limits) {
			const limit = this.limits[settingName];
			if (limit.min && !isNaN(settingValue) && parseInt(settingValue) < limit.min) {
				settingValue = limit.min;
			}
			if (limit.max && !isNaN(settingValue) && parseInt(settingValue) > limit.max) {
				settingValue = limit.max;
			}
		}
		this.props.changeCallback(settingName, settingValue);
	}

	getOpenaiApiKey() {
		return new Promise((resolve) => {
			const formData = new FormData();
			formData.append('action', 'get');

			fetch('ajax/openai-key.php', {
				method: 'POST',
				body: formData,
			})
			.then((response) => {
				if (response.status < 400) {
					return response.json();
				}
				resolve('');
			})
			.then((data) => {
				if (data.status === 'ok') {
					resolve(data.openaiApiKey);
				} else {
					resolve('');
				}
			})
			.catch((error) => {
				console.error(error);
				resolve('');
			});
		})
	}

	async componentDidMount() {
		const openaiApiKey = await this.getOpenaiApiKey();
		this.setState({
			openaiApiKey: openaiApiKey,
			oldOpenaiApiKey: openaiApiKey,
		});
	}

	componentWillUnmount() {
		if (this.state.openaiApiKey === this.state.oldOpenaiApiKey) {
			return;
		}
		const formData = new FormData();
		formData.append('action', 'set');
		formData.append('key', this.state.openaiApiKey);

		fetch('ajax/openai-key.php', {
			method: 'POST',
			body: formData,
		})
		.catch((error) => {
			console.error(error);
		});
	}

	prepareLangOptions() {
		const languageOptions = languages.map((lang) => {
			let key = 'language-' + lang.id;
			return (
				<option key={key} value={lang.langCode}>{lang.name} ({lang.langCode})</option>
			)
		});
		return languageOptions;
	}

	render() {
		const {permissions, isPro} = this.props;
		const openAiApiKeyInput = isPro
			? (<input id="openai-api-key" data-option="openaiApiKey" type="password" defaultValue={this.state.openaiApiKey} onInput={this.handleInput} autocomplete="new-password" />)
			: (<input id="openai-api-key" data-option="openaiApiKey" type="password" disabled />);
		return (
			<div className="settings">
				<button className="button-close" onClick={this.props.closeCallback}>&times;</button>
				<h2>Settings</h2>
				<p className="form-field">
					<label htmlFor="language">Language of your text</label>
					<select name="language" id="language" data-option="language" value={this.props.settings.language} onChange={this.handleInput}>{this.prepareLangOptions()}</select>
				</p>
				<p className="form-field">
					<label htmlFor="language">Provide related keywords based on</label>
					<select name="language" id="language" data-option="keywordSrc" value={this.props.settings.keywordSrc} onChange={this.handleInput}>
						{permissions.includes('content-related-keywords-ai') ? (<option value="entities">Entities based on AI SERP analysis</option>) : ''}
						{permissions.includes('content-related-keywords-ai') ? (<option value="ai">AI (single words and phrases)</option>) : ''}
						<option value="tfidf">TF IDF (single words)</option>
					</select>
				</p>
				<p className="form-field">
					<label htmlFor="openai-api-key">OpenAI API key {!isPro ? (<IconPadlock />) : ''}</label>
					{openAiApiKeyInput}
				</p>
				<p className="form-field">
					<label htmlFor="language">AI language model</label>
					<select name="ai-model" id="ai-model" data-option="aiModel" value={this.props.settings.aiModel} onChange={this.handleInput}>
						{permissions.includes('content-o1-allowed') ? (<option value="o1-preview">o1-preview</option>) : ''}
						<option value="gpt-4o">GPT-4o</option>
						<option value="gpt-4o-mini">GPT-4o mini</option>
					</select>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-per-sentence">Max number of words per sentence</label>
					<input
						type="number"
						min={this.limits.maxWordsPerSentence.min}
						max={this.limits.maxWordsPerSentence.max}
						id="max-words-per-sentence"
						data-option="maxWordsPerSentence"
						defaultValue={this.props.settings.maxWordsPerSentence}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-sentences-per-paragraph">Max number of sentences per paragraph</label>
					<input
						type="number"
						min={this.limits.maxSentencesPerParagraph.min}
						max={this.limits.maxSentencesPerParagraph.max}
						id="max-sentences-per-paragraph"
						data-option="maxSentencesPerParagraph"
						defaultValue={this.props.settings.maxSentencesPerParagraph}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-per-paragraph">Max number of words per paragraph</label>
					<input
						type="number"
						min={this.limits.maxWordsPerParagraph.min}
						max={this.limits.maxWordsPerParagraph.max}
						id="max-words-per-paragraph"
						data-option="maxWordsPerParagraph"
						defaultValue={this.props.settings.maxWordsPerParagraph}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-paragraphs-per-heading">Max number of paragraphs after each heading</label>
					<input
						type="number"
						min={this.limits.maxParagraphsPerHeading.min}
						max={this.limits.maxParagraphsPerHeading.max}
						id="max-paragraphs-per-heading"
						data-option="maxParagraphsPerHeading"
						defaultValue={this.props.settings.maxParagraphsPerHeading}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field">
					<label htmlFor="max-words-in-intro">Max number of words in 1st paragraph (intro text)</label>
					<input
						type="number"
						min={this.limits.maxWordsInIntro.min}
						max={this.limits.maxWordsInIntro.max}
						id="max-words-in-intro"
						data-option="maxWordsInIntro"
						defaultValue={this.props.settings.maxWordsInIntro}
						onInput={this.handleInput}
					/>
				</p>
				<p className="form-field min-max">
					<label htmlFor="min-keyword-density">Optimal keyword density</label>
					from: <input type="text" id="min-keyword-density" data-option="minKeywordDensity" defaultValue={this.props.settings.minKeywordDensity} onInput={this.handleInput} />
					to: <input type="text" id="max-keyword-density" data-option="maxKeywordDensity" defaultValue={this.props.settings.maxKeywordDensity} onInput={this.handleInput} />
				</p>
				<p className="form-field min-max">
					<label htmlFor="min-content-length">Optimal content length</label>
					from: <input type="text" id="min-content-length" data-option="minContentLength" defaultValue={this.props.settings.minContentLength} onInput={this.handleInput} />
					to: <input type="text" id="max-content-length" data-option="maxContentLength" defaultValue={this.props.settings.maxContentLength} onInput={this.handleInput} />
				</p>
				<p className="form-field">
					<label htmlFor="disallowed-words">Disallowed words (one per line)</label>
					<textarea id="disallowed-words" rows="10" data-option="disallowedWords" defaultValue={this.props.settings.disallowedWords} onInput={this.handleInput}></textarea>
				</p>
				<p className="form-submit"><button className="button primary" onClick={this.props.closeCallback}>OK</button></p>
			</div>
		)
	}
}

export default Settings;